import { render } from "./AuthChallengeDirect.vue?vue&type=template&id=002a32d6&ts=true"
import script from "./AuthChallengeDirect.vue?vue&type=script&lang=ts"
export * from "./AuthChallengeDirect.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__